import Vue from 'vue'
import Router from 'vue-router'
import login from '@/components/login/index.vue'
import register from '@/components/register/index.vue'
import layout from '@/components/layout/index.vue'
import index from '@/components/index/index.vue'
import planIndex from '@/components/plan/index.vue'
import about from '@/components/about/index.vue'
import message from '@/components/message/index.vue'
import demoApi from '@/components/demo/api.vue'
import downloadApp from '@/components/download/app.vue'
import memberCenter from '@/components/member/main.vue'
import memberIndex from '@/components/member/index.vue'
import memberRecharge from '@/components/member/recharge.vue'
import memberShare from '@/components/member/share.vue'
// 解决ElementUI导航栏中的vue-router在3.0版本以上重复点菜单报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router)

export default new Router({
    routes: [{
            path: '/login',
            name: 'login',
            component: login,
        },{
            path: '/register',
            name: 'register',
            component: register,
        },
        {
            path: '/demo/api',
            name: 'demoApi',
            component: demoApi,
        },
        {
            path: '/download/app',
            component: downloadApp,
        },
        {
            path: '/',
            name: 'layout',
            component: layout,
            children: [
                {
                    path: '/',
                    component: index,
                    name: 'index'
                },
                {
                    path: '/index',
                    component: index,
                    name: 'index'
                },
                {
                    //个人计划
                    path: '/index/:loty',
                    component: index,
                    name: 'planlaborIndex'
                },
                {
                    //公式计划
                    path: '/plan/:loty',
                    component: planIndex,
                    name: 'planIndex'
                },
                {
                    path: '/about',
                    component: about,
                },
                {
                    path: '/message',
                    component: message,
                },
                {
                    path: '/member/index',
                    name: 'memberCenter',
                    component: memberCenter,
                    children: [
                        {
                            path: '/member/index',
                            component: memberIndex,
                            name: 'memberIndex'
                        },
                        {
                            path: '/member/recharge',
                            component: memberRecharge,
                            name: 'memberRecharge'
                        },
                        {
                            path: '/member/share',
                            component: memberShare,
                            name: 'memberShare'
                        }
                    ]
                },
                
            ]
        }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js